import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchCurrentUser,
  getAuthToken,
  setAuthToken,
  updateCurrentUser,
} from "../Frontend/utils/authApi";

export const loadCurrentUser = createAsyncThunk(
  "auth/loadCurrentUser",
  async (_, { rejectWithValue }) => {
    try {
      return await fetchCurrentUser();
    } catch (error) {
      return rejectWithValue(error?.message ?? "Unable to load profile.");
    }
  },
);

export const updateProfile = createAsyncThunk(
  "auth/updateProfile",
  async (profileData, { rejectWithValue }) => {
    try {
      return await updateCurrentUser(profileData);
    } catch (error) {
      return rejectWithValue(error?.message ?? "Unable to update profile.");
    }
  },
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: getAuthToken(),
    status: "idle",
  },
  reducers: {
    setCredentials: (state, action) => {
      const { token, user } = action.payload;
      if (token) {
        state.token = token;
        setAuthToken(token);
      }
      if (user) {
        state.user = user;
      }
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.status = "idle";
      setAuthToken(null);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadCurrentUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadCurrentUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.user = action.payload;
      })
      .addCase(loadCurrentUser.rejected, (state) => {
        state.status = "failed";
        state.user = null;
        state.token = null;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        if (action.payload) {
          state.user = action.payload;
        }
      })
      .addCase(updateProfile.rejected, (state, action) => {
        if (action.payload === "Please sign in to update your profile.") {
          state.user = null;
          state.token = null;
        }
      });
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
